var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsCondition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:outline-list"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 9.2H2.55556V7.8H1V9.2ZM1 12H2.55556V10.6H1V12ZM1 6.4H2.55556V5H1V6.4ZM4.11111 9.2H15V7.8H4.11111V9.2ZM4.11111 12H15V10.6H4.11111V12ZM4.11111 5V6.4H15V5H4.11111ZM1 9.2H2.55556V7.8H1V9.2ZM1 12H2.55556V10.6H1V12ZM1 6.4H2.55556V5H1V6.4ZM4.11111 9.2H15V7.8H4.11111V9.2ZM4.11111 12H15V10.6H4.11111V12ZM4.11111 5V6.4H15V5H4.11111Z",
    fill: "#282828"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsCondition);
export default __webpack_public_path__ + "static/media/terms-condition.18dd4946f72520307a00277113647ae2.svg";
export { ForwardRef as ReactComponent };